module.exports = __webpack_public_path__ + "img/07.e8039f02.jpg";